module.exports = __webpack_public_path__ + "media/images/responsive/keywords/keyword_family-fc7fccefc76d0ccfc6753f77f091ccc8.jpg";